module.exports = __webpack_public_path__ + "media/images/thumbs_down-bbc8c0117aab0ee7b413ae0d619fcc19.png";